import { PaymentProviderService } from './../../../provider/payment-provider.service';
import { PaymentProviderModel } from './../../models/payment-provider.model';
import { Component, Input, OnInit } from '@angular/core';
import { AppHotelService } from 'src/app/provider/app-hotel.service';

@Component({
  selector: 'kt-payment-setup',
  templateUrl: './payment-setup.component.html',
  styleUrls: ['./payment-setup.component.scss']
})
export class PaymentSetupComponent implements OnInit {

  constructor(private paymentProviderService: PaymentProviderService, private hotelServ: AppHotelService) { }

  @Input() ID: number;
  provider: string = '';
  inputDisabled = false;
  buttonDisabled = false;
  providerTemp = true;
  useSandbox = false;
  paymentProvider: PaymentProviderModel = new PaymentProviderModel();
  hotelName = '';

  hotelID = Number(localStorage.getItem('hotelId'));

  ngOnInit() {

    this.hotelServ.getHotelInfo(this.hotelID).subscribe(resp => { this.hotelName = resp.name });

    this.paymentProviderService.getPayment()
      .then(resp => {
        if (resp['length'] > 0) {
          this.providerTemp = false;
          this.paymentProvider = resp[0];
          this.inputDisabled = true;
          this.buttonDisabled = true;
        }
      }
        , err => {
          console.log(err);
        })
  }



  send() {

    if (this.paymentProvider.provider === 'Garanti') {
      this.paymentProvider.description = 'Garanti Bankası';
      this.paymentProvider.use_3_d = true;
      this.paymentProvider.security_type = '3D_PAY';
      this.paymentProvider.name = this.hotelName;
      this.paymentProvider.use_sandbox = this.useSandbox;
    }
    if (this.paymentProvider.provider === 'Stripe') {
      this.paymentProvider.description = 'Stripe';
      this.paymentProvider.server = 'https://api.stripe.com';
      this.paymentProvider.name = this.hotelName;
    }
    if (this.paymentProvider.provider === 'Genesis') {
      this.paymentProvider.use_3_d = true;
      this.paymentProvider.transaction_type = 'sale3d';
      this.paymentProvider.server = this.useSandbox ? 'https://staging.wpf.e-comprocessing.net/wpf' : 'https://wpf.e-comprocessing.net/wpf';
      this.paymentProvider.description = 'IKAPOS';
      this.paymentProvider.use_sandbox = this.useSandbox;
      this.paymentProvider.name = this.hotelName;
    }
    if (this.paymentProvider.provider === 'Iyzico') {
      this.paymentProvider.description = 'Iyzico';
      this.paymentProvider.name = this.hotelName;
    }
    console.log(this.paymentProvider);
    this.paymentProviderService.postPayment(this.paymentProvider)
      .then(resp => console.log(resp));
    this.providerTemp = false;
    this.inputDisabled = true;
    this.buttonDisabled = true;
    window.location.reload();

  }


  delete(id: number) {
    this.paymentProviderService.deletePayment(id)
      .then(resp => {
        console.log(resp);
      })
      .catch(err => {
        console.log(err);
      })
    this.providerTemp = true;
    this.inputDisabled = false;
    this.buttonDisabled = false;
    this.paymentProvider = new PaymentProviderModel();

  }


  edit() {
    this.inputDisabled = !this.inputDisabled;
  }



  update() {
    this.paymentProviderService.postPayment(this.paymentProvider)
      .then(resp => console.log(resp))
    this.inputDisabled = !this.inputDisabled;
  }


  useSandboxHandler() {
    this.useSandbox = !this.useSandbox;
    console.log(this.useSandbox);
  }


}
